module.exports = __webpack_public_path__ + "static/media/4.5aadbf56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/4.jpg
// module id = 537
// module chunks = 0